import React from "react";
import { CodeInput } from "../Form/CodeField";
import BaseDialog from "./BaseDialog";

interface ModalCodeEditorProps {
  isOpen: boolean;
  onClose: () => void;
  value: string;
  onChange: any;
  label?: string;
  placeholder?: string;
  isDisabled?: boolean;
  language?: string;
}

const ModalCodeEditor: React.FC<ModalCodeEditorProps> = ({
  isOpen,
  onClose,
  value,
  onChange,
  label,
  placeholder,
  isDisabled,
  language,
}) => {
  return (
    <BaseDialog isOpen={isOpen} onOpenChange={onClose} title="Code" size="4xl">
      <div className="flex min-h-120">
        <CodeInput
          placeholder={placeholder}
          label={label}
          onChange={onChange}
          value={value}
          isDisabled={isDisabled}
          isExpanded
          language={language}
        />
      </div>
    </BaseDialog>
  );
};

export default ModalCodeEditor;
